import { stringify } from 'qs';
import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IDealDocument } from 'views/DocumentLibrary/types';
import { DealDocumentType } from 'views/DocumentLibrary/constants';

export interface IFilters {
    types?: DealDocumentType[];
    folders?: (number | string)[];
}

const getDocumentLibraryDocuments = async (dealId: number, filters?: IFilters): Promise<IDealDocument[]> => {
    const params = { deal_id: dealId, ...(filters || {}) };

    const response = await axiosInstance.get(API_ENDPOINTS.DEAL_DOCUMENTS.DOCUMENTS, {
        params,
        paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
    });
    return response.data;
};

export const useGetDocumentLibraryDocuments = (dealId: number, filters?: IFilters, options = {}) => useQuery({
    queryKey: [QUERY_KEYS.DOCUMENT_LIBRARY_DOCUMENTS, dealId, filters],
    queryFn: () => getDocumentLibraryDocuments(dealId, filters),
    staleTime: 5000,
    refetchOnMount: true,
    ...options,
});

export default useGetDocumentLibraryDocuments;
